import React, { useState, useEffect } from "react";
import {
  listarParticipantes,
  extrairRelatorioUsuarios,
} from "../../services/http/apiLogin";
import Header from "../../components/Header";
import "./styles.css";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { FaRegAddressCard, FaMagnifyingGlass } from "react-icons/fa6";
import { BiDetail } from "react-icons/bi";
import { saveAxiosBlobAs } from "../../helpers/saveAxiosBlobAs";

export default function Participante() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [perfilFilter, setPerfilFilter] = useState("");
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const history = useHistory();
  const itemsPerPage = 10;

  async function fnListaParticipante(search, perfil, status, page = 1) {
    setLoading(true);
    setError(null);
    try {
      // Converter perfil para isAdmin
      let isAdmin = "";
      if (perfil === "f2409814-a5ba-41d6-a71a-a9ec17c6f0e8") {
        isAdmin = "true";
      } else if (perfil === "889e7779-c6ab-4409-b6af-470e56a38dbf") {
        isAdmin = "false";
      }

      let response = await listarParticipantes(
        search,
        isAdmin,
        status,
        page,
        itemsPerPage
      );
      console.log("API Response:", response.data); // Debug log

      // Verificar se a resposta tem a estrutura esperada
      if (!response.data || !Array.isArray(response.data.data)) {
        console.error(
          "Resposta da API não tem a estrutura esperada:",
          response.data
        );
        setData([]);
        setTotalItems(0);
        setTotalPages(0);
        return;
      }

      setData(response.data.data);

      // Extrair informações de paginação da resposta da API
      let totalItems = 0;
      let totalPages = 0;

      // Verificar se a API retorna totalItems
      if (response.data.totalItems !== undefined) {
        totalItems = response.data.totalItems;
        setTotalItems(totalItems);
      }

      // Verificar se a API retorna totalPages
      if (response.data.totalPages !== undefined) {
        totalPages = response.data.totalPages;
        setTotalPages(totalPages);
      } else {
        // Calcular totalPages se não vier da API
        totalItems = response.data.totalItems || response.data.data.length;
        totalPages = Math.ceil(totalItems / itemsPerPage);
        setTotalItems(totalItems);
        setTotalPages(totalPages);
      }

      // Garantir que sempre tenhamos pelo menos 1 página
      if (totalPages === 0 && response.data.data.length > 0) {
        setTotalPages(1);
        setTotalItems(response.data.data.length);
      }

      console.log("Calculated pagination:", {
        totalItems,
        totalPages,
        currentPage: page,
      }); // Debug log
    } catch (err) {
      console.error("Erro ao carregar participantes:", err);
      setError(`Erro ao carregar a lista de participantes: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }

  // Dados paginados (agora vêm diretamente da API)
  const paginatedData = data;

  useEffect(() => {
    fnListaParticipante("", "", "", 1);
  }, []);

  // Limpar timeout quando componente for desmontado
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fnListaParticipante(searchTerm, perfilFilter, statusFilter, pageNumber);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
    // Buscar com debounce para melhor performance
    clearTimeout(searchTimeout);
    const timeoutId = setTimeout(() => {
      fnListaParticipante(e.target.value, perfilFilter, statusFilter, 1);
    }, 500);
    setSearchTimeout(timeoutId);
  };

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
    setCurrentPage(1);
    fnListaParticipante(searchTerm, perfilFilter, e.target.value, 1);
  };

  const clearFilters = () => {
    setSearchTerm("");
    setStatusFilter("");
    setPerfilFilter("");
    setCurrentPage(1);
    fnListaParticipante("", "", "", 1);
  };

  const handleExtrairRelatorio = async () => {
    try {
      setLoading(true);
      const response = await extrairRelatorioUsuarios();
      saveAxiosBlobAs(response, "relatorio-usuarios.xlsx");
    } catch (error) {
      console.error("Erro ao extrair relatório:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePerfilFilter = (e) => {
    setCurrentPage(1);
    setPerfilFilter(e.target.value);
    fnListaParticipante(searchTerm, e.target.value, statusFilter, 1);
  };

  if (loading) {
    return (
      <>
        <Header mostrarPesquisar={false} />
        <div className="container">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden"></span>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header mostrarPesquisar={false} />
      <div className="container">
        {/* Header Section */}
        <div className="page-header p-2">
          <div className="page-title">
            <h1>Lista de Usuários</h1>
            <p className="text-muted">Gerencie os usuários do sistema</p>
          </div>
        </div>

        {/* Filters Section */}
        <div
          className="filters-section p-3"
          style={{
            backgroundColor: "#E4E4E483",
            borderRadius: "10px",
            marginBottom: "20px",
          }}
        >
          <div className="filters-container">
            <div className="row g-3 pb-4">
              <div className="col-12 col-md-4">
                <label
                  htmlFor="searchInput"
                  className="form-label fw-semibold text-secondary"
                >
                  Buscar Usuário
                </label>
                <input
                  type="text"
                  id="searchInput"
                  className="form-control"
                  style={{
                    height: "42px",
                    fontSize: "14px",
                    border: "1px solid #b1b1b1",
                    borderRadius: "5px",
                    color: "#495057",
                  }}
                  placeholder="Nome, userName ou email..."
                  value={searchTerm}
                  onChange={handleSearch}
                />
              </div>

              <div className="d-flex flex-column col-12 col-md-2">
                <label
                  htmlFor="statusSelect"
                  className="form-label fw-semibold text-secondary"
                >
                  Status
                </label>
                <select
                  id="statusSelect"
                  className="form-select"
                  value={statusFilter}
                  onChange={handleStatusFilter}
                  style={{
                    height: "42px",
                    fontSize: "14px",
                    border: "1px solid #b1b1b1",
                    borderRadius: "5px",
                    color: "#495057",
                  }}
                >
                  <option value="">Todos os status</option>
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                  <option value="Pendente">Pendente</option>
                </select>
              </div>

              <div className="d-flex flex-column col-12 col-md-2">
                <label
                  htmlFor="perfilSelect"
                  className="form-label fw-semibold text-secondary"
                >
                  Perfil
                </label>
                <select
                  id="perfilSelect"
                  className="form-select"
                  value={perfilFilter}
                  onChange={handlePerfilFilter}
                  style={{
                    height: "42px",
                    fontSize: "14px",
                    border: "1px solid #b1b1b1",
                    borderRadius: "5px",
                    color: "#495057",
                  }}
                >
                  <option value="">Todos os perfis</option>
                  <option value="889e7779-c6ab-4409-b6af-470e56a38dbf">
                    Participante
                  </option>
                  <option value="f2409814-a5ba-41d6-a71a-a9ec17c6f0e8">
                    Administrador
                  </option>
                </select>
              </div>

              <div className="col-12 col-md-2 d-flex align-items-end mt-3">
                <button
                  className="btn btn-secondary w-100"
                  onClick={handleExtrairRelatorio}
                  disabled={loading}
                  style={{
                    height: "42px",
                  }}
                >
                  <FaMagnifyingGlass size={18} className="me-2" />
                  {loading ? "Extraindo..." : "Extrair Relatório"}
                </button>
              </div>
              <div className="col-12 col-md-2 d-flex align-items-end">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => history.push("/usuario/novo/perfil")}
                  style={{
                    height: "42px",
                  }}
                >
                  <FaRegAddressCard size={18} className="me-2" />
                  Novo Usuário
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-container">
          <table className="participants-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>UserName</th>
                <th>Email</th>
                <th>Telefone</th>
                <th>CPF/CNPJ</th>
                <th>Status</th>
                <th className="text-end">Ações</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData?.length > 0 ? (
                paginatedData.map((participante) => (
                  <tr key={participante.id}>
                    <td>{participante.nome}</td>
                    <td>{participante.userName}</td>
                    <td>{participante.email}</td>
                    <td>
                      {participante.phoneNumber
                        ? participante.phoneNumber.replace(
                            /(\d{2})(\d{5})(\d{4})/,
                            "($1) $2-$3"
                          )
                        : "-"}
                    </td>
                    <td>
                      {participante.cpfCnpj
                        ? participante.cpfCnpj.length === 11
                          ? participante.cpfCnpj.replace(
                              /(\d{3})(\d{3})(\d{3})(\d{2})/,
                              "$1.$2.$3-$4"
                            )
                          : participante.cpfCnpj.replace(
                              /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                              "$1.$2.$3/$4-$5"
                            )
                        : "-"}
                    </td>
                    <td>
                      <span
                        className={`status ${
                          participante.status === "Ativo"
                            ? "ativo"
                            : participante.status === "Inativo"
                            ? "inativo"
                            : "precadastro"
                        }`}
                      >
                        {participante.status}
                      </span>
                    </td>
                    <td
                      className="text-end"
                      style={{ filter: "brightness(0)", width: "100px" }}
                    >
                      <div
                        className=" d-flex justify-content-center mr-3"
                        onClick={() => {
                          history.push(
                            `/usuario/editar/perfil/${participante.id}`
                          );
                        }}
                        title="Ver detalhes"
                      >
                        <BiDetail size={26} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-5">
                    <div className="empty-state">
                      <span className="text-muted" style={{ fontSize: "3rem" }}>
                        👥
                      </span>
                      <p className="text-muted mt-3">
                        {error
                          ? "Erro ao carregar dados"
                          : "Nenhum participante encontrado"}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 0 && (
          <div className="pagination">
            <button
              className="pagination-button"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage <= 1}
            >
              Anterior
            </button>

            <div className="pagination-numbers">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  className={`pagination-number ${
                    currentPage === index + 1 ? "active" : ""
                  }`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <button
              className="pagination-button"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              Próximo
            </button>
          </div>
        )}
      </div>
    </>
  );
}
